var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18V12M12.5 12L9.5 14M12.5 12L15.5 14M13.5 3.00087C13.4045 3 13.2973 3 13.1747 3H8.7002C7.58009 3 7.01962 3 6.5918 3.21799C6.21547 3.40973 5.90973 3.71547 5.71799 4.0918C5.5 4.51962 5.5 5.08009 5.5 6.2002V17.8002C5.5 18.9203 5.5 19.4801 5.71799 19.9079C5.90973 20.2842 6.21547 20.5905 6.5918 20.7822C7.01921 21 7.579 21 8.69694 21L16.3031 21C17.421 21 17.98 21 18.4074 20.7822C18.7837 20.5905 19.0905 20.2842 19.2822 19.9079C19.5 19.4805 19.5 18.9215 19.5 17.8036V9.32568C19.5 9.20296 19.5 9.09561 19.4991 9M13.5 3.00087C13.7856 3.00347 13.9663 3.01385 14.1388 3.05526C14.3429 3.10425 14.5379 3.18526 14.7168 3.29492C14.9186 3.41857 15.0918 3.59182 15.4375 3.9375L18.563 7.06298C18.9089 7.40889 19.0809 7.58136 19.2046 7.78319C19.3142 7.96214 19.3953 8.15726 19.4443 8.36133C19.4857 8.53376 19.4963 8.71451 19.4991 9M13.5 3.00087V5.8C13.5 6.9201 13.5 7.47977 13.718 7.90759C13.9097 8.28392 14.2155 8.59048 14.5918 8.78223C15.0192 9 15.579 9 16.6969 9H19.4991M19.4991 9H19.5002",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/File_Upload.eeb88815b6c315fbfd643f6ea78c1401.svg";
export { ForwardRef as ReactComponent };